import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight, Star, Sparkles } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
export function PricingOptions() {
  const basicFeatures = ['Acceso a los 6 Tomos completos', 'Los 6 Bonos de regalo', 'Actualizaciones de por vida'];
  const proFeatures = [{
    text: 'Incluye todo lo del Mega Pack básico',
    highlight: false
  }, {
    text: '30 casos clínicos resueltos paso a paso',
    highlight: true
  }, {
    text: 'Casos organizados por región y complejidad',
    highlight: false
  }, {
    text: 'Ideal para exámenes, prácticas e internado',
    highlight: false
  }];
  return <AnimatedSection id="pricing" className="bg-navy-950 relative overflow-hidden" data-id="element-200">
      {/* Subtle dot pattern */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" data-id="element-201">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle, rgba(201,168,76,0.4) 1px, transparent 1px)',
        backgroundSize: '40px 40px'
      }} data-id="element-202" />
      </div>

      {/* Ambient glows */}
      <div className="absolute top-1/4 -left-32 w-[500px] h-[500px] bg-gold/[0.05] blur-[120px] rounded-full pointer-events-none" data-id="element-203"></div>
      <div className="absolute bottom-1/4 -right-32 w-[500px] h-[500px] bg-emerald-500/[0.06] blur-[120px] rounded-full pointer-events-none" data-id="element-204"></div>

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-205">
        <div className="text-center mb-8 sm:mb-10" data-id="element-206">
          <div className="inline-block px-3 py-1 rounded-full border border-gold/30 bg-gold/5 text-gold text-[10px] sm:text-xs font-bold tracking-[0.15em] uppercase mb-4 sm:mb-5" data-id="element-207">
            Tu inversión
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-6xl font-heading font-extrabold text-white leading-[1.05] mb-3" data-id="element-208">
            Elegí tu{' '}
            <span className="font-editorial italic text-gold font-medium" data-id="element-209">
              Mega Pack
            </span>
          </h2>
          <p className="text-sm sm:text-base text-gray-400" data-id="element-210">
            Dos formas de entrar al sistema. Una sola decisión.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5 md:gap-5 items-stretch max-w-3xl md:max-w-none mx-auto pt-4" data-id="element-211">
          {/* OPTION 1 — Basic */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-b from-navy-900 to-navy-950 backdrop-blur-sm border-2 border-gold/50 rounded-3xl p-5 sm:p-6 flex flex-col relative shadow-[0_0_40px_rgba(201,168,76,0.18)]" data-id="element-212">
            {/* Plan inicial pill */}
            <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 z-10" data-id="element-213">
              <div className="inline-flex items-center gap-1.5 bg-gold text-navy-950 font-bold px-4 py-1.5 rounded-full text-[10px] sm:text-xs tracking-[0.15em] uppercase shadow-[0_4px_20px_rgba(201,168,76,0.4)]" data-id="element-214">
                <Sparkles size={12} className="fill-navy-950" data-id="element-215" />
                Plan Inicial
              </div>
            </div>

            <div className="mb-4 mt-1" data-id="element-216">
              <h3 className="text-lg sm:text-xl font-heading font-bold text-white mb-1.5 flex items-center gap-2 leading-tight" data-id="element-217">
                <span className="text-xl" data-id="element-218">📘</span> MEGA PACK KINESIOLOGÍA
              </h3>
              <p className="text-gold/90 text-sm" data-id="element-219">6 Tomos + 6 Bonos</p>
            </div>

            <div className="mb-4" data-id="element-220">
              <div className="text-red-400/80 line-through text-base sm:text-lg mb-1" data-id="element-221">
                $51.000
              </div>
              <div className="flex items-baseline gap-2" data-id="element-222">
                <span className="text-3xl sm:text-4xl font-heading font-extrabold text-white tracking-tight" data-id="element-223">
                  $19.990
                </span>
                <span className="text-xs text-gray-500 font-semibold tracking-widest uppercase" data-id="element-224">
                  ARS
                </span>
              </div>
            </div>

            <ul className="space-y-2.5 mb-5 flex-1" data-id="element-225">
              {basicFeatures.map((feat, idx) => <li key={idx} className="flex items-start gap-3 text-sm sm:text-base text-gray-200" data-id="element-226">
                  <div className="mt-0.5 w-5 h-5 rounded-full bg-gold/15 border border-gold/40 flex items-center justify-center flex-shrink-0" data-id="element-227">
                    <Check size={12} className="text-gold" strokeWidth={3} data-id="element-228" />
                  </div>
                  <span data-id="element-229">{feat}</span>
                </li>)}
            </ul>

            <a href="https://checkout.atlasclinico.com/cart/45616781394022:1" target="_blank" rel="noopener noreferrer" className="group block w-full text-center bg-gold/10 hover:bg-gold/20 text-gold border border-gold/40 hover:border-gold/60 font-bold text-sm sm:text-base px-6 py-3 rounded-2xl transition-all" data-id="element-230">
              <span className="inline-flex items-center gap-2" data-id="element-231">
                <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-232" />
                QUIERO MI MEGA PACK
              </span>
            </a>
          </motion.div>

          {/* OPTION 2 — Featured */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-gradient-to-b from-navy-900 to-navy-950 border-2 border-emerald-500 rounded-3xl p-5 sm:p-6 flex flex-col relative shadow-[0_0_60px_rgba(16,185,129,0.25)]" data-id="element-233">
            {/* MÁS ELEGIDO pill */}
            <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 z-10" data-id="element-234">
              <div className="inline-flex items-center gap-1.5 bg-emerald-500 text-white font-bold px-4 py-1.5 rounded-full text-[10px] sm:text-xs tracking-[0.15em] uppercase shadow-[0_4px_20px_rgba(16,185,129,0.4)]" data-id="element-235">
                <Star size={12} className="fill-white" data-id="element-236" />
                MÁS ELEGIDO
              </div>
            </div>

            <div className="mb-4 mt-1" data-id="element-237">
              <h3 className="text-lg sm:text-xl font-heading font-bold text-white mb-1.5 flex items-center gap-2 leading-tight" data-id="element-238">
                <span className="text-xl" data-id="element-239">🏆</span> MEGA PACK + RAZONAMIENTO
                AVANZADO
              </h3>
              <p className="text-emerald-400 text-sm leading-snug" data-id="element-240">
                6 Tomos + 6 Bonos + 30 casos clínicos resueltos
              </p>
            </div>

            <div className="mb-4" data-id="element-241">
              <div className="text-red-400/80 line-through text-base sm:text-lg mb-1" data-id="element-242">
                $69.000
              </div>
              <div className="flex items-baseline gap-2" data-id="element-243">
                <span className="text-3xl sm:text-4xl font-heading font-extrabold text-white tracking-tight" data-id="element-244">
                  $27.990
                </span>
                <span className="text-xs text-gray-500 font-semibold tracking-widest uppercase" data-id="element-245">
                  ARS
                </span>
              </div>
            </div>

            <ul className="space-y-2.5 mb-5 flex-1" data-id="element-246">
              {proFeatures.map((feat, idx) => <li key={idx} className={`flex items-start gap-3 text-sm sm:text-base ${feat.highlight ? 'bg-emerald-500/10 border border-emerald-500/30 rounded-lg px-3 py-2 -mx-1 text-white font-semibold' : 'text-gray-200'}`} data-id="element-247">
                  <div className={`mt-0.5 w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 ${feat.highlight ? 'bg-emerald-500 border border-emerald-400' : 'bg-emerald-500/15 border border-emerald-500/30'}`} data-id="element-248">
                    <Check size={12} className={feat.highlight ? 'text-white' : 'text-emerald-400'} strokeWidth={3} data-id="element-249" />
                  </div>
                  <span data-id="element-250">{feat.text}</span>
                </li>)}
            </ul>

            <a href="https://checkout.atlasclinico.com/cart/45616790143078:1" target="_blank" rel="noopener noreferrer" className="group block w-full text-center bg-emerald-500 hover:bg-emerald-400 text-navy-950 font-extrabold text-sm sm:text-base px-6 py-3 rounded-2xl transition-all transform hover:scale-[1.02] shadow-[0_10px_30px_rgba(16,185,129,0.3)]" data-id="element-251">
              <span className="inline-flex items-center gap-2" data-id="element-252">
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-253" />
                QUIERO EL PACK + AVANZADO
              </span>
            </a>
          </motion.div>
        </div>

        {/* Trust strip below */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="flex flex-wrap justify-center items-center gap-x-4 sm:gap-x-6 gap-y-2 mt-8 text-xs sm:text-sm text-gray-400" data-id="element-254">
          <div className="flex items-center gap-1.5" data-id="element-255">
            🛡️ <span data-id="element-256">Garantía 7 días</span>
          </div>
          <span className="text-gray-600" data-id="element-257">·</span>
          <div className="flex items-center gap-1.5" data-id="element-258">
            🔒 <span data-id="element-259">Pago seguro</span>
          </div>
          <span className="text-gray-600" data-id="element-260">·</span>
          <div className="flex items-center gap-1.5" data-id="element-261">
            💳 <span data-id="element-262">Mercado Pago · Tarjeta · Transferencia</span>
          </div>
        </motion.div>
      </div>
    </AnimatedSection>;
}